import { render, staticRenderFns } from "./npcPocketDialog.vue?vue&type=template&id=2db81aaa&scoped=true&"
import script from "./npcPocketDialog.vue?vue&type=script&lang=js&"
export * from "./npcPocketDialog.vue?vue&type=script&lang=js&"
import style0 from "./npcPocketDialog.vue?vue&type=style&index=0&id=2db81aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db81aaa",
  null
  
)

export default component.exports